var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54438 5.061L11.9994 2L17.4554 5.061L15.4554 6.194L11.9994 4.261L8.54938 6.194L6.54438 5.061ZM17.4544 8.928L15.4544 7.794L11.9994 9.728L8.54938 7.794L6.54438 8.928V11.188L9.98838 13.122V16.983L11.9994 18.117L14.0054 16.983V13.123L17.4554 11.189L17.4544 8.928ZM17.4544 15.056V12.789L15.4544 13.922V16.183L17.4544 15.056ZM18.8834 15.856L15.4334 17.783V20.05L20.8884 16.983V10.861L18.8834 11.989V15.856ZM16.8774 6.994L18.8774 8.128V10.388L20.8884 9.261V6.994L18.8834 5.861L16.8774 7V6.994ZM9.98838 18.606V20.866L11.9994 22L14.0054 20.867V18.61L11.9994 19.74L9.99438 18.606H9.98838ZM6.54438 15.05L8.54438 16.183V13.923L6.54438 12.789V15.056V15.05ZM9.98838 6.994L11.9994 8.128L14.0054 6.994L11.9994 5.861L9.99438 7L9.98838 6.994ZM5.11638 8.128L7.12138 6.994L5.12138 5.861L3.11138 7V9.267L5.11638 10.395V8.128ZM5.11638 11.989L3.10938 10.861V16.983L8.56538 20.05V17.778L5.12138 15.85V11.983L5.11638 11.989Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.99763fdcdfe5c642d834876b1aafe0bc.svg";
export { ForwardRef as ReactComponent };